
import { useState, useCallback } from "react";

export const useEmergencyFieldState = <T>(
  initialValue: T, 
  exerciseId: string, 
  fieldName: string,
  onUpdate: (exerciseId: string, field: string, value: T) => void
) => {
  const [localValue, setLocalValue] = useState<T>(initialValue);

  const updateValue = useCallback((newValue: T) => {
    console.log(`🚨 EMERGENCY: Updating ${fieldName} for ${exerciseId}:`, newValue);
    
    // Always update local state immediately
    setLocalValue(newValue);
    
    // Queue the update (fire and forget)
    onUpdate(exerciseId, fieldName, newValue);
  }, [exerciseId, fieldName, onUpdate]);

  const syncFromProps = useCallback((propValue: T) => {
    // Only sync if significantly different to avoid unnecessary updates
    if (JSON.stringify(propValue) !== JSON.stringify(localValue)) {
      console.log(`🚨 EMERGENCY: Syncing ${fieldName} from props:`, propValue);
      setLocalValue(propValue);
    }
  }, [localValue, fieldName]);

  return {
    value: localValue,
    updateValue,
    syncFromProps
  };
};
